import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

import type { Entity } from '../../types'
import * as fragments from '../fragments'

const DOC = gql`
  ${fragments.rule.DOC}
  query Rule(
    $tenantId: ID!
    $zoneId: ID!
    $appId: ID!
    $scenarioId: ID!
    $ruleId: ID!
  ) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        app(id: $appId) {
          scenario(id: $scenarioId) {
            extra {
              rate {
                rule(id: $ruleId) {
                  ...FragmentRateRule
                }
              }
            }
          }
        }
      }
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.select<
  graphql.schema.RuleQuery,
  Entity | undefined,
  'tenant'
>(
  'tenant',
  graphql.transformers.OUT.select(
    'zone',
    graphql.transformers.OUT.select(
      'app',
      graphql.transformers.OUT.select(
        'scenario',
        graphql.transformers.OUT.select(
          'extra',
          graphql.transformers.OUT.select(
            'rate',
            graphql.transformers.OUT.select('rule', fragments.rule.TRANSFORMER),
          ),
        ),
      ),
    ),
  ),
)

export const executor = graphql.createExecutor<
  graphql.schema.RuleQuery,
  Entity | undefined,
  graphql.schema.RuleQueryVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
